import { Checkbox, Group, Stack, Text, TextInput } from '@mantine/core';
import { tKeys, useTranslate } from 'locales/index';
import { useState } from 'react';
import { isTruthy } from 'remeda';
import { emailRegex } from 'shared/utils/validation';

export type ReminderEmail = { value: string; selected: boolean };

type ReminderEmailRecipientsProps = {
  emails: Array<ReminderEmail>;
  onToggle: (index: number) => void;
  onAdd: (value: string) => void;
};

export const ReminderEmailRecipients = ({
  emails,
  onToggle,
  onAdd,
}: ReminderEmailRecipientsProps) => {
  const t = useTranslate();
  const [draft, setDraft] = useState('');
  const [error, setError] = useState<string | null>(null);

  const submitDraft = () => {
    const value = draft.trim();
    if (!isTruthy(value)) return;
    if (!emailRegex.test(value)) {
      setError(t(tKeys.ERROR.INVALID_EMAIL));
      return;
    }
    setDraft('');
    if (emails.some(email => email.value === value)) return;
    onAdd(value);
  };

  return (
    <Stack gap="xs">
      <Text size="sm" fw={500}>
        {t(tKeys.EMAILS)}
      </Text>
      {emails.map((email, index) => (
        <Group key={email.value} gap="xs" wrap="nowrap">
          <Checkbox
            checked={email.selected}
            onChange={() => onToggle(index)}
            aria-label={email.value}
          />
          <Text size="sm">{email.value}</Text>
        </Group>
      ))}
      <TextInput
        aria-label={t(tKeys.FORM.CLIENT.ADD_EMAIL)}
        placeholder={t(tKeys.FORM.CLIENT.ADD_EMAIL)}
        value={draft}
        error={error}
        onChange={event => {
          setDraft(event.currentTarget.value);
          setError(null);
        }}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            submitDraft();
          }
        }}
      />
    </Stack>
  );
};
